export const MESSAGES_TEXT = {
  success: {
    addLinkedAccountAdultSuccess: 'Linked Account message sent successfully',
    addLinkedAccountMinorSuccess: 'account added successfully',
    linkRequestActionSuccess: {
      accept: (fullName: string) => `${fullName}'s account linked successfully`,
      decline: 'Account link declined',
    },
    removeLinkedAccountSuccess: 'Access removed successfully',
    removeLinkedAccountMinorSuccess: 'Access removed successfully',
  },
  error: {
    loadLinkedAccountsFailure: `We're not able to load your Linked Accounts at this time. Please try again later.`,
    linkAlreadyExists: `We are unable to complete your request. These accounts are already linked.`,
    selfAccountLinkError: `You cannot link to your own account. To share access, enter <strong>the other person's</strong> account information.`,
    addLinkedAccountAdultFailure: `We can't find the person you requested based on the information you provided.`,
    addLinkedAccountAdultExists: (fullName: string) =>
      `Your Linked Account message was not sent. You've already sent a request to ${fullName}. You can click <b>Resend Linking Request</b> on ${
        fullName.split(' ')[0]
      }'s card to remind them to respond.`,
    addLinkedAccountMinorFailure: `could not be added at this time. Please check your entry and try again. Ensure your personal information, such as home address, is entered accurately and exactly matches the information in your account.`,
    addLinkedAccountMinorExists: `is on someone else's MyLabcorp account. Contact the adult account holder to request access to their information.`,
    linkRequestActionFailure: {
      accept:
        'We are unable to accept access at this time. Please try again later.',
      decline:
        'We are unable to decline access at this time. Please try again later.',
    },
    removeLinkedAccountFailure:
      'We are unable to remove access at this time. Please try again later.',
    removeLinkedAccountMinorFailure:
      'We are unable to remove access at this time. Please try again later.',
    minorAccountExistsOrAddressMismatch: (fullName: string) =>
      `${fullName}'s account could not be added at this time. If you think that ${
        fullName.split(' ')[0]
      } may be on someone else’s account, contact the adult account holder to request access. If you think you’ve received this message in error, contact Customer Service at 855-522-2677.`,
  },
};
